export { default } from "./disclaimer";
